// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useContext} from 'react';
import {useLocation} from 'react-router-dom';
import {qs_parse} from 'zurl';
import {Data_context} from '../data_ctx';
import {use_pathname} from './use_pathname';

type get_data_id_fn = (params:object_of<string>, pathname: string)=>string;
export const use_data_provider = (get_data_id:get_data_id_fn)=>{
    const {params} = use_pathname();
    const {search, pathname} = useLocation();
    const qs_o = qs_parse(search.substr(1), {safe: true});
    const full_params = {...params, ...qs_o};
    const data = useContext(Data_context);
    const data_id = get_data_id(full_params, pathname);
    return {
        data: data[data_id] || {result: undefined, status: 'unavailable'},
        clear_cache: data.clear_cache,
    };
};
